import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Divider, Form, Button, InputNumber, TimePicker, DatePicker, Tooltip, Input, message } from 'antd';
import { setNextReservationsByRestaurantId } from '../../../actions/setNextReservationsByRestaurantId';
import { setNewStateToReserve } from '../../../actions/setNewStateToReserve';
import { getRestaurant, getNextReservations } from '../../../reducers';
import LoadingPage from '../../../components/LoadingPage';
import cloneDeep from 'lodash.clonedeep';
import { cloudFunctions, db } from '../../../config/Fire';
import * as Constants from '../../../constants/nodes_database';
import { RESERVE_STATE } from '../../../constants/reserve';
import './styles.css';

const ReservationById = props => {
    const [form] = Form.useForm();
    const [form2] = Form.useForm();

    const[reservation, setReservation] = useState(null)
    const[loading, setLoading] = useState(false)
    const[users, setUsers] = useState(null)
    const[isSaving, setIsSaving] = useState(false)
    const[joiningNewUser, setJoiningNewUser] = useState(false)

    const getNextReservations = () => {
        console.log("getNextReservations")
        if(!props.nextReservations) {
            if(props.restaurant) {
                console.log("setNextReservationsByRestaurantId")
                props.setNextReservationsByRestaurantId(props.restaurant.id);
            }
        }
        return <LoadingPage className="LoadingPageCont"/>
    }

    const getReservation = () => {
        if(props.location && props.location.pathname && props.location.pathname.split("/").length === 4) {
            const pathSplited = props.location.pathname.split("/")
            if(props.nextReservations && props.nextReservations[pathSplited[3]]) {
                setReservation(props.nextReservations[pathSplited[3]])
                const users = {}
                props.nextReservations[pathSplited[3]].users.forEach(user => {
                    users[user.id] = user
                });
                setUsers(users)
            } else {
                return <h1>Error</h1>
            }
        } else {
            return <h1>Error location</h1>
        }
    }

    useEffect(() => {
        if(props.location && props.location.pathname && props.location.pathname.split("/").length === 4) {
            const pathSplited = props.location.pathname.split("/")
            if(props.nextReservations && props.nextReservations[pathSplited[3]]) {
                setReservation(props.nextReservations[pathSplited[3]])
                const users = {}
                props.nextReservations[pathSplited[3]].users.forEach(user => {
                    users[user.id] = user
                });
                setUsers(users)
                Object.values(users).forEach(user => {
                    if(user.assisted) {
                        form.setFieldsValue({
                            [`field_check_in_hour_${user.id}`]: user.checkInRestaurant !== "" ? moment(user.checkInRestaurant, 'HH:mm DD/MM/YYYY') : undefined,
                            [`field_check_in_date_${user.id}`]: user.checkInRestaurant !== "" ? moment(user.checkInRestaurant, 'HH:mm DD/MM/YYYY') : undefined,
                            [`field_check_out_hour_${user.id}`]: user.checkOutRestaurant !== "" ? moment(user.checkOutRestaurant, 'HH:mm DD/MM/YYYY') : undefined,
                            [`field_check_out_date_${user.id}`]: user.checkOutRestaurant !== "" ? moment(user.checkOutRestaurant, 'HH:mm DD/MM/YYYY') : undefined,
                            [`field_temperature_${user.id}`]: user.temperature
                        })
                    }
                });
            }
        }
    }, [props.nextReservations])

    const onUserAssistChange = user => {
        const usersToChange = cloneDeep(users)
        usersToChange[user.id].assisted = !user.assisted
        setUsers(usersToChange)
        form.setFieldsValue({
            [`field_check_in_hour_${user.id}`]: user.checkInRestaurant !== "" ? moment(user.checkInRestaurant, 'HH:mm DD/MM/YYYY') : moment().utcOffset('-0300'),
            [`field_check_in_date_${user.id}`]: user.checkInRestaurant !== "" ? moment(user.checkInRestaurant, 'HH:mm DD/MM/YYYY') : moment().utcOffset('-0300'),
            [`field_check_out_date_${user.id}`]: user.checkOutRestaurant !== "" ? moment(user.checkOutRestaurant, 'HH:mm DD/MM/YYYY') : moment().utcOffset('-0300')
        })
    }

    const onSubmit = values => {
        const promisesUsersUpdated = [];
        var isReserveAssisted = false
        Object.values(users).forEach(userAssisted => {
            if(userAssisted.assisted === true) {
                isReserveAssisted = true
            }
        });
        Object.values(users).forEach(user => {
            reservation.users.forEach((userInDB, index) => {
                if(userInDB.id === user.id) {
                    var userCheckIn = user.assisted ? `${moment(values[`field_check_in_hour_${user.id}`]).format("HH:mm")} ${moment(values[`field_check_in_date_${user.id}`]).format("DD/MM/YYYY")}` : ""
                    var userCheckOut = (!user.assisted || (values[`field_check_out_hour_${user.id}`] !== undefined && values[`field_check_out_date_${user.id}`] !== undefined)) ? `${moment(values[`field_check_out_hour_${user.id}`]).format("HH:mm")} ${moment(values[`field_check_out_date_${user.id}`]).format("DD/MM/YYYY")}` : ""
                    if(user.assisted !== userInDB.assisted) {
                        const updateUserByCFRef = cloudFunctions.tryChangeAssistanceUserInReservation({
                            reservationId: reservation.reservationId,
                            userId: user.id,
                            userAssisted: user.assisted,
                            userCheckIn: userCheckIn,
                            userCheckOut: userCheckOut,
                            userTemperature: values[`field_temperature_${user.id}`] !== undefined ? values[`field_temperature_${user.id}`].toString() : "",
                        })
                        promisesUsersUpdated.push(updateUserByCFRef)
                    } else {
                        const updateUserRef = db.ref(`${Constants.RESERVATIONS}/${reservation.reservationId}/users/${index}`).update({
                            checkInRestaurant: userCheckIn,
                            checkOutRestaurant: userCheckOut,
                            temperature: values[`field_temperature_${user.id}`] !== undefined ? values[`field_temperature_${user.id}`].toString() : "",
                            state: isReserveAssisted ? RESERVE_STATE.assisted : RESERVE_STATE.accepted
                        })
                        promisesUsersUpdated.push(updateUserRef)
                        const updateReservationByUserRef = db.ref(`${Constants.RESERVATIONS_BY_USER}/${user.id}/${reservation.reservationId}`).update({
                            state: isReserveAssisted ? RESERVE_STATE.assisted : RESERVE_STATE.accepted
                        })
                        promisesUsersUpdated.push(updateReservationByUserRef)
                    }
                }
            });
        });
        setIsSaving(true)
        return Promise.all(promisesUsersUpdated)
        .then(() => {
            setIsSaving(false)
            message.success("Usuarios modificados exitósamente")
        })
        .catch(err => {
            setIsSaving(false)
            message.error("Se produjo un error al modificar los usuarios")
        })
    }

    const onSubmitNewUserJoined = values => {
        console.log("Nuevo invitado: " + JSON.stringify(values))
        if(reservation) {
            setJoiningNewUser(true)
            return cloudFunctions.tryJoinReserveByRestaurant({
                reservationId: reservation.reservationId,
                userId: "",
                userEmail: values.field_email2,
                userPhone: values.field_phone,
                userDNI: values.field_dni,
                userFirstName: values.field_first_name,
                userLastName: values.field_last_name,
                userStreet: values.field_street,
                userCity: values.field_city,
                userProvince: values.field_province,
                userCountry: values.field_country
            })
            .then((response) => {
                if(response.data !== undefined && response.data.code === 0) {
                    setJoiningNewUser(false)
                    message.error("Usuario añadido a la reserva.");
                    onClearNewUserJoined()
                } else {
                    setJoiningNewUser(false)
                    console.log("tryJoinReserveByRestaurant: " + JSON.stringify(response))
                    if(response.data !== undefined) {
                        switch (response.data.message) {
                            case "user email reservation already joined":
                                message.error("El usuario ya se encuentra en la reserva.");
                                break;
                            default:
                                message.error("La reserva no es válida. Por favor, vuelva a intentarlo.");
                                break;
                        }
                    }
                }
            })
            .catch(err => {
                message.error("La reserva no es válida. Por favor, vuelva a intentarlo.");
                console.log("tryJoinReserveByRestaurant err: " + JSON.stringify(err))
            })
        } else {
            message.error("La reserva no es válida. Por favor, vuelva a intentarlo.");
        }
    }

    const onClearNewUserJoined = () => {
        form2.resetFields();
    }

    return (
        <div className="reservationByIdCont">
            {
                props.restaurant ?
                    props.nextReservations ?
                        reservation ?
                            <Grid className="reservationByIdGrid">
                                <Row start="xs" center="md">
                                    <Col xs={6} md={4}>
                                        <h2>Fecha: {reservation.date}</h2>
                                    </Col>
                                    <Col xs={6} md={4}>
                                        <h2>Hora: {reservation.hour}</h2>
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <h2>Creada: {moment(reservation.createdAt, 'DD/MM/YYYY HH:mm:ss').utcOffset('-0300').format('DD/MM/YYYY HH:mm')}</h2>
                                    </Col>
                                </Row>
                                <Row>
                                </Row>
                                <Row start="xs">
                                    <Col xs={12}>
                                        <Divider orientation="left">Invitados</Divider>
                                    </Col>
                                </Row>
                                <Form onFinish={onSubmit} form={form}>
                                    <Row center="xs" className="listUsersRow">
                                        {
                                            users &&
                                            Object.values(users).map(user => {
                                                return(
                                                <Col xs={12} className="userCol" key={`${user.id}`}>
                                                    <Row center="xs">
                                                        <Col xs={12} sm={12} md={4}>
                                                            <h3>{user.reserveOwner ? "Dueño de la reserva" : "Invitado"}: {`${user.firstName} ${user.lastName}`}</h3>
                                                        </Col>
                                                        <Col xs={12} sm={12} md={4}>
                                                            <h3>DNI: {user.dni}</h3>
                                                        </Col>
                                                        <Col xs={12} sm={12} md={4}>
                                                            <h3>Email: {user.email}</h3>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xs={12} className="formUserFieldCol">
                                                            <Form.Item name={`button_assist_${user.id}`}>
                                                                <Button type="dashed" onClick={() => onUserAssistChange(user)}>{`${user.assisted ? "No asistió" : "Asistió"}`}</Button>
                                                            </Form.Item>
                                                        </Col>
                                                        {
                                                            user.assisted &&
                                                                <Col xs={6} md={3} lg={2} className="formUserFieldCol">
                                                                    <Tooltip title="Hora de entrada" placement="top">
                                                                        <Form.Item name={`field_check_in_hour_${user.id}`} rules={[{ required: true, message: "Por favor, complete la hora de ingreso" }]}>
                                                                            <TimePicker format={'HH:mm'} placeholder={"Hora de entrada"}/>
                                                                        </Form.Item>
                                                                    </Tooltip>
                                                                </Col>
                                                        }
                                                        {
                                                            user.assisted &&
                                                                <Col xs={6} md={3} lg={2} className="formUserFieldCol">
                                                                    <Tooltip title="Fecha de entrada" placement="top">
                                                                        <Form.Item name={`field_check_in_date_${user.id}`} rules={[{ required: true, message: "Por favor, complete la fecha de ingreso" }]}>
                                                                            <DatePicker format={'DD/MM/YYYY'} placeholder={"Fecha de entrada"}/>
                                                                        </Form.Item>
                                                                    </Tooltip>
                                                                </Col>
                                                        }
                                                        {
                                                            user.assisted &&
                                                                <Col xs={6} md={3} lg={2} className="formUserFieldCol">
                                                                    <Tooltip title="Hora de salida" placement="top">
                                                                        <Form.Item name={`field_check_out_hour_${user.id}`}>
                                                                            <TimePicker format={'HH:mm'} placeholder={"Hora de salida"}/>
                                                                        </Form.Item>
                                                                    </Tooltip>
                                                                </Col>
                                                        }
                                                        {
                                                            user.assisted &&
                                                                <Col xs={6} md={3} lg={2} className="formUserFieldCol">
                                                                    <Tooltip title="Fecha de salida" placement="top">
                                                                        <Form.Item name={`field_check_out_date_${user.id}`}>
                                                                            <DatePicker format={'DD/MM/YYYY'} placeholder={"Fecha de salida"}/>
                                                                        </Form.Item>
                                                                    </Tooltip>
                                                                </Col>
                                                        }
                                                        {
                                                            user.assisted &&
                                                                <Col xs={12} md={12} lg={4} className="formUserFieldCol">
                                                                    <Tooltip title="Temperatura" placement="top">
                                                                        <Form.Item name={`field_temperature_${user.id}`}>
                                                                            <InputNumber
                                                                            formatter={value => `${value}ºC`}
                                                                            parser={value => value.replace('ºC', '')}
                                                                            />
                                                                        </Form.Item>
                                                                    </Tooltip>
                                                                </Col>
                                                        }
                                                    </Row>
                                                </Col>
                                                )
                                            })
                                        }
                                        <Col xs={12}>
                                            <Form.Item>
                                            {
                                                isSaving ?
                                                    <Button type="primary" htmlType="submit" disabled={true} loading>
                                                        Guardando
                                                    </Button>
                                                    :
                                                    reservation.state === RESERVE_STATE.pending ?
                                                        <Tooltip title="Primero debe aceptar la reserva" placement="top">
                                                            <Button type="primary" htmlType="submit" disabled={true}>
                                                                Guardar
                                                            </Button>
                                                        </Tooltip>
                                                        :
                                                        <Button type="primary" htmlType="submit">
                                                            Guardar
                                                        </Button>
                                            }
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                                <Row start="xs">
                                    <Col xs={12}>
                                        <Divider orientation="left">Agregar usuario a la reserva</Divider>
                                    </Col>
                                </Row>
                                <Form onFinish={onSubmitNewUserJoined} form={form2} className="joinNewUserFormCont" initialValues={{
                                field_city: (props.restaurant && props.restaurant.address && props.restaurant.address.city) ? props.restaurant.address.city : undefined,
                                field_province: (props.restaurant && props.restaurant.address && props.restaurant.address.province) ? props.restaurant.address.province : undefined,
                                field_country: (props.restaurant && props.restaurant.address && props.restaurant.address.country) ? props.restaurant.address.country : undefined,
                                }}>
                                    <Row>
                                        <Col xs={12} sm={6}>
                                            <Form.Item name="field_first_name" rules={[ { required: true, message: 'Por favor, ingrese el/los nombre/s' } ]}>
                                                <Input placeholder="Nombre/s" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12} sm={6}>
                                            <Form.Item name="field_last_name" rules={[ { required: true, message: 'Por favor, ingrese el/los apellido/s' } ]}>
                                                <Input placeholder="Apellido/s" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={6}>
                                            <Form.Item name="field_dni" rules={[ { required: true, message: 'Por favor, ingrese el DNI' } ]}>
                                                <Input type="number" placeholder="dni" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12} sm={6}>
                                            <Form.Item name="field_email2" rules={[ { type: 'email', message: 'El correo no es válido', }, { required: false, message: 'Por favor, ingrese el correo electrónico' } ]}>
                                                <Input placeholder="Correo electrónico" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={6}>
                                            <Form.Item name="field_phone" rules={[ { required: true, message: 'Por favor, ingrese el teléfono' } ]}>
                                                <Input type="number" placeholder="Teléfono" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12} sm={6}>
                                            <Form.Item name="field_street" rules={[ { required: true, message: 'Por favor, ingrese la dirección' } ]}>
                                                <Input placeholder="Dirección" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={6}>
                                            <Form.Item name="field_city" rules={[ { required: true, message: 'Por favor, ingrese la ciudad' } ]}>
                                                <Input placeholder="Ciudad" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12} sm={6}>
                                            <Form.Item name="field_province" rules={[ { required: true, message: 'Por favor, ingrese la provincia' } ]}>
                                                <Input placeholder="Provincia" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={6}>
                                            <Form.Item name="field_country" rules={[ { required: true, message: 'Por favor, ingrese el país' } ]}>
                                                <Input placeholder="País" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>
                                            <Form.Item>
                                            {
                                                joiningNewUser ?
                                                    <Button disabled={true} loading>
                                                        Limpiar campos
                                                    </Button>
                                                    :
                                                    reservation.state === RESERVE_STATE.pending ?
                                                        <Tooltip title="Primero debe aceptar la reserva" placement="top">
                                                            <Button disabled={true}>
                                                                Limpiar campos
                                                            </Button>
                                                        </Tooltip>
                                                        :
                                                        <Button disabled={false} onClick={onClearNewUserJoined}>
                                                            Limpiar campos
                                                        </Button>
                                            }
                                            </Form.Item>
                                        </Col>
                                        <Col xs={6}>
                                            <Form.Item>
                                            {
                                                joiningNewUser ?
                                                    <Button type="primary" htmlType="submit" disabled={true} loading>
                                                        Unirse
                                                    </Button>
                                                    :
                                                    reservation.state === RESERVE_STATE.pending ?
                                                        <Tooltip title="Primero debe aceptar la reserva" placement="top">
                                                            <Button type="primary" htmlType="submit" disabled={true}>
                                                                Unirse
                                                            </Button>
                                                        </Tooltip>
                                                        :
                                                        <Button type="primary" htmlType="submit" disabled={false}>
                                                            Unirse
                                                        </Button>
                                            }
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </Grid>
                            :
                            getReservation()
                        :
                        getNextReservations()
                    :
                    <LoadingPage className="LoadingPageCont"/>
            }
        </div>
    );
};

ReservationById.propTypes = {
    
};

const mapDispatchToPropsActions = dispatch => ({
    setNextReservationsByRestaurantId: value => dispatch(setNextReservationsByRestaurantId(value)),
    setNewStateToReserve: (state, newState, id) => dispatch(setNewStateToReserve(state, newState, id)),
});

const mapStateToProps = state => ({ 
    restaurant:  getRestaurant(state),
    nextReservations: getNextReservations(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(ReservationById));